import React from 'react';
import BoardFunctional from './components/board-functional';

const Board = () => {
	return <BoardFunctional />;
};

export default Board;
